import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import styles from "./styles.module.scss";

interface RedirectCountdownProps {
  visible: boolean;
  onRedirect: () => void;
  duration?: number; // in seconds
}

const RedirectCountdown: React.FC<RedirectCountdownProps> = ({
  visible,
  onRedirect,
  duration = 4,
}) => {
  const [timeLeft, setTimeLeft] = useState(duration);

  useEffect(() => {
    if (!visible) {
      setTimeLeft(duration);
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          onRedirect();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [visible, duration, onRedirect]);

  if (!visible) return null;

  return (
    <div className={styles.redirectCountdown}>
      <div className={styles.content}>
        <div className={styles.title}>Resident did not consent</div>
        <div className={styles.spinnerContainer}>
          <Spin
            size="large"
            indicator={
              <LoadingOutlined
                style={{ fontSize: 48, color: "#161646" }}
                spin
              />
            }
          />
        </div>
        <div className={styles.subtitle}>
          Redirecting to Vitals AI in{" "}
          <span className={styles.countdown}>{timeLeft}</span> seconds...
        </div>
      </div>
    </div>
  );
};

export default RedirectCountdown;
